import { ReactNode } from 'react';

import { ResponseMessage } from '@/shared/types/tryIt';

import { responseClasses } from './constants';

type WebviewMessage = Extract<ResponseMessage, { type: 'webview' | 'survey' }>;

interface WebviewResponseProps {
  response: WebviewMessage;
  icon: ReactNode;
  goToButton: ReactNode;
}

export const WebviewResponse = ({ response, icon, goToButton }: WebviewResponseProps) => {
  return (
    <div className={responseClasses}>
      {icon}
      <div className="mx-1 mb-2 flex h-30 w-55 flex-col rounded-xl bg-background shadow-sm">
        <p className="overflow-hidden px-3 py-2 text-ellipsis">{response.name}</p>
        <div className="flex min-h-0 w-full flex-1 items-center justify-center rounded-b bg-bg-muted-50">
          <p className="w-4/5 overflow-hidden rounded bg-background px-4 py-2 text-center font-semibold text-ellipsis">
            {response.label}
          </p>
        </div>
      </div>
      {goToButton}
    </div>
  );
};
